export default "__VITE_ASSET__PTsGguG9__"